import { BrowserModule } from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgxUiLoaderModule, NgxUiLoaderConfig, SPINNER, PB_DIRECTION } from 'ngx-ui-loader';
import { ToastrModule } from 'ngx-toastr';
import { ClipboardModule } from 'ngx-clipboard';
import { MonacoEditorModule } from 'ngx-monaco-editor-v2';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { Hl7viewerComponent } from './hl7viewer/hl7viewer.component';
import { AddMappingDialogComponent } from './hl7viewer/add-mapping-dialog/add-mapping-dialog.component';
import { SaveAllConfirmationDialogComponent } from './hl7viewer/save-all-confirmation-dialog/save-all-confirmation-dialog.component';
import { ExpressionBuilderComponent } from './hl7viewer/add-mapping-dialog/expression-builder/expression-builder.component';
import { AppConfigService } from './services/app-config.service';

export function initializeApp(appConfigService: AppConfigService) {
  return () => appConfigService.load();
}

const ngxUiLoaderConfig: NgxUiLoaderConfig = {
  bgsSize: 50,
  bgsType: SPINNER.threeStrings,
  fgsType: SPINNER.threeStrings,
  fgsSize: 80,
  pbDirection: PB_DIRECTION.leftToRight,
  pbThickness: 5,
  overlayColor: 'rgba(20,20,20,.6)'
};

@NgModule({
  declarations: [
    AppComponent,
    Hl7viewerComponent,
    AddMappingDialogComponent,
    SaveAllConfirmationDialogComponent,
    ExpressionBuilderComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    AppRoutingModule,
    NgbModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    NgxUiLoaderModule.forRoot(ngxUiLoaderConfig),
    ToastrModule.forRoot({
      positionClass: 'toast-bottom-right',
      timeOut: 3000,
      preventDuplicates: true
    }),
    ClipboardModule,
    MonacoEditorModule.forRoot()
  ],
  providers: [
    AppConfigService,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [AppConfigService],
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }

